/**
 * @generated SignedSource<<be61c850ed8f4a9c2dc95fa00df339b8>>
 * @relayHash 8025168f3eb350232b122cef7c1ffda8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ef218579eac389d3f55044af985f841cb14fdf9b282e077be8fd1f5db6aa89d3

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PopupContentNav3Query } from './PopupContentNav3Query.graphql';

const node: PreloadableConcreteRequest<PopupContentNav3Query> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ef218579eac389d3f55044af985f841cb14fdf9b282e077be8fd1f5db6aa89d3",
    "metadata": {},
    "name": "PopupContentNav3Query",
    "operationKind": "query",
    "text": null
  }
};

export default node;
